import { isGlobalFeatureEnabled } from "owa-feature-flags";
import { SearchScenarioId } from "owa-search-store";
import isWin32StylingEnabled from "owa-theme-win32-style-store/lib/selectors/isWin32StylingEnabled";

export function isSearchBoxWin32ParityEnabled(scenarioId: SearchScenarioId): boolean {
    return (isGlobalFeatureEnabled("sea-searchBoxWin32Parity") &&
        isWin32StylingEnabled() &&
        (scenarioId === SearchScenarioId.Mail || scenarioId === SearchScenarioId.Calendar));
}
